<script setup>
import Icon from './Icon.vue';

defineProps({
  options: { type: Array, required: true }
});
const model = defineModel({ type: String, required: true });
</script>

<template>
  <div class="segmented" role="tablist">
    <button
      v-for="opt in options"
      :key="opt.value"
      type="button"
      role="tab"
      class="seg"
      :class="{ active: model === opt.value }"
      :aria-selected="model === opt.value"
      @click="model = opt.value"
    >
      <Icon v-if="opt.icon" :name="opt.icon" :size="15" />
      {{ opt.label }}
      <span v-if="opt.count !== undefined" class="count">{{ opt.count }}</span>
    </button>
  </div>
</template>

<style scoped lang="scss">
.segmented {
  display: inline-flex;
  padding: 3px;
  gap: 2px;
  border-radius: 10px;
  background: var(--track-bg);
}

.seg {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 28px;
  padding: 0 12px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-2);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.15s, color 0.15s;

  &:hover {
    color: var(--text);
  }

  &.active {
    background: var(--surface);
    color: var(--text);
    box-shadow: var(--shadow-1), 0 0 0 1px rgba(23, 20, 42, 0.04);
  }
}

.count {
  min-width: 18px;
  padding: 0 5px;
  border-radius: 999px;
  background: var(--track-line);
  font-size: 11px;
  line-height: 18px;
  text-align: center;
}
</style>
